export enum CaptureUserAuditOutcomeStatusReason {
  missingReferralValidation = 'missing_referral_validation',
  missingPatientValidation = 'missing_patient_validation',
  missingPrescriberValidation = 'missing_prescriber_validation',
  missingSpecialtyValidation = 'missing_specialty_validation',
  missingDrugValidation = 'missing_drug_validation',
  missingEncounterValidation = 'missing_encounter_validation',
  other = 'other',
}
